<div class="bp-modal mod-lg">
  @if (announcement) {
    <bp-modal-header [title]="'introducing_announcement_modal_header' | translate">
      <a right (click)="save()" (keydown.enter)="save()" [tabIndex]="0">{{ "close" | translate }}</a>
    </bp-modal-header>
    <div class="bp-modal-body text-center">
      <div class="bp-modal-body-section pt-20">
        @if (announcement.hasImageSource()) {
          <div class="pb-40">
            <img
              class="center-block img-responsive"
              [src]="announcement.getImageSource()"
              [alt]="'announcement_alt_text' | translate" />
          </div>
        }
        <h2 class="mb-15">{{ announcement.getTitle() }}</h2>
        <p class="text-light linebreak mb-10">{{ announcement.getBody() }}</p>
        <button
          class="modal-add-info-button btn btn-primary btn-bold btn-bigger-text"
          tabindex="501"
          (click)="onButtonClick()"
          type="button">
          @if (announcement.hasLinkDescription()) {
            {{ announcement.getLinkDescription() }}
          }
          @if (!announcement.hasLinkDescription()) {
            {{ buttonOkKey | translate }}
          }
        </button>
      </div>
    </div>
  }
</div>
